// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {"__root":{"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function matchStateV5_decode($$enum) {
  if ($$enum === "NEW_BROADCAST" || $$enum === "NEW" || $$enum === "INITIAL" || $$enum === "SUCCESSIVE") {
    return $$enum;
  }
  
}

function matchStateV5_fromString(str) {
  return matchStateV5_decode(str);
}

var Utils = {
  matchStateV5_decode: matchStateV5_decode,
  matchStateV5_fromString: matchStateV5_fromString
};

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuietPropertyMatchPopup_matchForBuyerNeedV5",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ToggleMatchDismissButton_matchV5"
    }
  ],
  "type": "MatchForBuyerNeedV5",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
